import { useLocation } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { AdminHeader } from "./AdminHeader";
import { useAdminSocket } from "@/lib/adminSocket";
import { useAdminReviewQueueSync } from "@/portals/admin/hooks/useAdminReviewQueueSync";

const pageMeta: Record<string, { title: string; description: string }> = {
  "/admin/users":       { title: "Patients",    description: "All patients registered through the MedSyncIQ patient portal" },
  "/admin/audit-trail": { title: "Audit Trail", description: "Every upload, login, and clinical-record activity across MedSyncIQ" },
  "/admin/physicians":  { title: "Physicians",  description: "Invite physicians and see who has joined the physician portal" },
  "/admin/review-queue": { title: "Review Queue", description: "Medication review items waiting for a physician" },
};

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  // Admin-only realtime (Module 6): created here, so only admin sessions ever connect it.
  useAdminSocket();
  useAdminReviewQueueSync();
  const meta = location.pathname.startsWith("/admin/users/")
    ? { title: "Patient Details", description: "Profile and assigned physician" }
    : pageMeta[location.pathname];

  return (
    <div className="flex h-screen overflow-hidden bg-[#F7F7F7]">
      <AdminSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AdminHeader title={meta?.title} description={meta?.description} />
        <main id="admin-content" className="msq-route-main flex-1 overflow-y-auto bg-[#F7F7F7]">
          {children}
        </main>
      </div>
    </div>
  );
}
